export default __webpack_public_path__ + "static/media/corporate-voucher.d75732e9.svg";